module.exports = __webpack_public_path__ + "img/dongji_ps_12.071bb0f0.jpg";